<template>
  <div class="address contentarea">
    <div>
      <span>{{data.title}}</span>
      <span>{{data.ruby}}</span>
    </div>
    <div>{{data.address}}</div>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }

  .address{
    margin-bottom: 90px !important;
		border: 1px solid #707070;
    text-align: left;
    line-height: 2;
    div{
      &:nth-of-type(1){
        padding: 50px 40px 0;
        .screen-xs({
          padding: 25px 20px 0;
        });
      }
      &:nth-of-type(2){
        padding: 0 40px 50px;
        .screen-xs({
          padding: 0 20px 25px;
        });
      }
    }
    span{
      &:nth-of-type(1){
        font-size: 20px;
        font-weight: bold;
      }
      &:nth-of-type(2){
        padding-left: 10px;
      }
    }
  }
</style>

<script>
  export default {
    name: 'Address',
    props: {
      data: Object
    }
  }
</script>